import React, {useState} from "react";
import "./LocatorControls.css";
import geoLocate from "../resources/icons/geoLocate.svg";
import {
  AdvancedMarker,
  ControlPosition,
  MapControl,
  useMap,
} from "@vis.gl/react-google-maps";

function LocatorControls() {
  const map = useMap();
  const [userLocation, setUserLocation] = useState<google.maps.LatLngLiteral>();
  const [userLocationFailed, setUserLocationFailed] = useState(false);

  return (
    <>
      {userLocation && <AdvancedMarker position={userLocation} />}
      <MapControl position={ControlPosition.RIGHT_CENTER}>
        <button
          className="locatorControls"
          onClick={() => {
            if (userLocation && map) map.setCenter(userLocation);
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                  const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                  };
                  setUserLocationFailed(false);
                  setUserLocation(pos);
                  if (map) map.setCenter(pos);
                },
                (error) => {
                  setUserLocationFailed(true);
                },
                {timeout: 10000},
              );
            } else {
              setUserLocationFailed(true);
            }
          }}
        >
          <svg width={32} height={32} id="geoLocateIcon">
            {userLocationFailed ? (
              <>
                <title>Standort kann nicht ermittelt werden</title>
                <use href={geoLocate + "#geoLocateDisabled"}></use>
              </>
            ) : (
              <>
                <title>Standort anzeigen</title>
                <use href={geoLocate + "#geoLocateNeutral"}></use>
              </>
            )}
          </svg>
        </button>
      </MapControl>
    </>
  );
}

export default LocatorControls;
